import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import QuoteEdit from './quoteEdit';
import utils from '../../misc/utils';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import Quotes from './quotes';

import SendIcon from 'material-ui/svg-icons/content/send';

class QuotesInactive extends Quotes {
  constructor(props, context) {
    super(props, context);
    
    this.state.scope = 'inactive';
  }

  render() {    
    return Quotes.prototype.render.call(this);
  }
}

export default QuotesInactive;


/** WEBPACK FOOTER **
 ** ./src/app/routes/quotes/quotes.inactive.js
 **/